import ArrowRight from '@bits/icons/ArrowRight';
import SimpleBlockContent from '@bits/SimpleBlockContent';
import iub from '@utils/ImageUrlBuilder';
import Carousel from 'nuka-carousel';
import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './index.module.scss';

type SizeProps = {
  width: number;
  height: number;
};

const useWindowSize = (): SizeProps => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = (): void => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  return windowSize;
};

type SlideProps = {
  slides?: [
    {
      title;
      text;
      image;
    }
  ];
};

const Slider: FunctionComponent<SlideProps> = (slider) => {
  const size = useWindowSize();
  const [slideIndex, setSlideIndex] = useState(0);

  return (
    <div className={styles.root}>
      <Carousel
        slidesToShow={size.width <= 768 ? 1 : 2.7}
        slideIndex={slideIndex}
        afterSlide={(slideIndex) => setSlideIndex(slideIndex)}
        wrapAround={true}
        renderBottomCenterControls={null}
        renderCenterLeftControls={null}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide} className={styles.nextBtn}>
            <ArrowRight color={'white'} />
          </button>
        )}>
        {slider?.slides?.map((slide, key) => (
          <div key={key} className={styles.slider}>
            <div
              style={{ backgroundImage: `url(${iub(slide.image.asset).width(600).url()})` }}
              title={`${slide.image.alt}`}
              className={`${styles.img} ${slideIndex == key && styles.removeOverlay}`}
            />
          </div>
        ))}
      </Carousel>
      <div className={styles.fixedBottom}>
        {slider?.slides?.map((slide, key) => (
          <div key={key}>
            <div className={`${slideIndex == key ? styles.title : styles.none}`}>
              <p> {slide.title} </p>
            </div>
            <div className={`${slideIndex == key ? styles.textContent : styles.none}`}>
              <SimpleBlockContent data={slide.text} />
            </div>
          </div>
        ))}
        <p className={styles.pagination}>
          {slideIndex + 1} / {slider?.slides?.length}
        </p>
      </div>
    </div>
  );
};

export default Slider;
